import { Hero } from "../sections/Hero";
import { Pillars } from "../sections/Pillars";
import { Engineering } from "../sections/Engineering";
import { ProductsSection } from "../sections/ProductsSection";
import { Differentiators } from "../sections/Differentiators";
import { SelectedWork } from "../sections/SelectedWork";
import { Process } from "../sections/Process";
import { GlobalReach } from "../sections/GlobalReach";
import { CTASection } from "../sections/CTASection";

/**
 * The homepage, read as one argument rather than nine sections:
 *
 *   what we do        → Hero, Pillars
 *   can they build it → Engineering
 *   what have they    → Products, SelectedWork
 *   why them          → Differentiators
 *   how do I engage   → Process, GlobalReach, CTA
 *
 * Products come before "why us" on purpose. The evidence should arrive
 * before the argument; a reader who has seen two systems running is a much
 * cheaper audience for six claims than one who has not.
 */
export function Home() {
  return (
    <>
      <Hero />
      <Pillars />
      <Engineering />
      <ProductsSection />
      <SelectedWork />
      <Differentiators />
      <Process />
      <GlobalReach />
      <CTASection />
    </>
  );
}
